import { Fragment, useCallback, useContext, useRef, useState } from "react";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import { menuRoutes } from "../../../router/menu";
import PageHeader from "../../../layout/shared/page-header";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { Button } from "rizzui";
import { Headquarter } from "../../../type/entities/headquarter-type";
import cn from "../../../utils/classNames";
import HeadquartersList from "./HeadquartersList";
import HeadquarterImportModal from "../components/HeadquarterImportModal";
import { HiOutlineTrash } from "react-icons/hi2";

const HeadquartersListWrapper = () => {

    // STATES

    const [isOpenFormDrawer, setIsOpenFormDrawer] = useState(false);
    const [headquarterSelected, setHeadquarterSelected] = useState<Headquarter | null>(null);
    const [openDeleteAllModal, setOpenDeleteAllModal] = useState(false);
    const [isOpenImportModal, setIsOpenImportModal] = useState(false);
    const headquartersTableRefetchRef = useRef<(() => void) | null>(null);

    const registerTableRefetch = useCallback((fn: () => void) => {
        headquartersTableRefetchRef.current = fn;
    }, []);

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de sedes' },
        { name: 'Sedes', href: menuRoutes.headquarters.path },
    ];

    const defaultFilters = {};

    // HOOKS

    const { userCan } = useContext(PrivilegeContext);

    // RENDER

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters} >
                <PageHeader title="Listado de sedes" breadcrumb={breadCrumb}>
                    <div className="flex gap-3 mt-4 md:mt-0">
                    {
                            userCan('delete_all', 'headquarter') &&
                            (
                                <Button color="danger" onClick={() => setOpenDeleteAllModal(true)} className={cn(['mt-4 md:mt-0'])}>
                                    <HiOutlineTrash className="w-4 h-4" />
                                    <span className="ms-2">Eliminar todas las sedes</span>
                                </Button>
                            )
                        }
                        {userCan('import', 'headquarter') && (
                            <Button
                                variant="outline"
                                onClick={() => setIsOpenImportModal(true)}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Importar sedes
                            </Button>
                        )}
                        {userCan('create', 'headquarter') && (
                            <Button
                                color="primary"
                                onClick={() => {
                                    setIsOpenFormDrawer(true);
                                    setHeadquarterSelected(null);
                                }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Crear sede
                            </Button>
                        )}
                    </div>
                </PageHeader>
                <HeadquartersList
                    openFormDrawer={isOpenFormDrawer}
                    setOpenFormDrawer={setIsOpenFormDrawer}
                    headquarterSelected={headquarterSelected}
                    setHeadquarterSelected={setHeadquarterSelected}
                    openDeleteAllModal={openDeleteAllModal}
                    setOpenDeleteAllModal={setOpenDeleteAllModal}
                    registerTableRefetch={registerTableRefetch}
                />
                <HeadquarterImportModal
                    isOpen={isOpenImportModal}
                    onClose={() => setIsOpenImportModal(false)}
                    refetch={() => headquartersTableRefetchRef.current?.()}
                />
            </FiltersProvider>
        </Fragment>
    );
};

export default HeadquartersListWrapper;